<template>
  <div>
    <v-row no-gutters class="my-5">
      <v-col cols="12" sm="6" md="4">
        <park-select
          v-model="credentials.parkId"
          :is-edit="Boolean($route.params.autoId)"
        />

        <v-text-field
          ref="number"
          v-model="credentials.number"
          :label="$t('auto.fields.number') + ' *'"
          :placeholder="$t('auto.fields.numberPlaceholder')"
          :loading="numberValidating"
          :rules="rules.number"
          :error-messages="numberErrors"
          :disabled="isNumberDisabled"
          type="text"
          class="ma-2"
          autocomplete="off"
          @blur="validateIsAutoExisting"
          @input="numberErrors = []"
        />
        <div cols="12" sm="6" md="4" class="ma-2">
          <brand-select
            :label="$t('auto.fields.brand') + ' *'"
            :rules="rules.brand"
          />
        </div>
        <div cols="12" sm="6" md="4" class="ma-2">
          <model-select
            :label="$t('auto.fields.model') + ' *'"
            :rules="rules.model"
          />
        </div>
        <v-text-field
          v-model="credentials.year"
          :label="$t('auto.fields.year') + ' *'"
          :placeholder="$t('auto.fields.yearPlaceholder')"
          :rules="rules.year"
          v-mask="'####'"
          type="text"
          class="ma-2"
          autocomplete="off"
        />
        <v-select
          :items="types"
          v-model="credentials.carTypeId"
          class="ma-2"
          :label="$t('auto.fields.type') + ' *'"
          item-text="title"
          item-value="id"
          :hide-details="false"
        ></v-select>
        <v-text-field
          v-model="credentials.color"
          class="ma-2"
          :label="$t('auto.fields.color') + ' *'"
          :rules="rules.color"
        />
        <v-combobox
          v-model="credentials.responsible_fines_id"
          :items="responsibles"
          :label="$t('auto.fields.responsible_fines')"
          item-value="userId"
          item-text="name"
          class="ma-2"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <div cols="12" sm="6" md="4" class="ma-2">
          <v-select
            v-model="credentials.rentRateId"
            item-value="id"
            :label="$t('rates.title')"
            :items="$store.state.rates.list"
            :item-text="(i) => `${i.name} (${i.rate}%)`"
            :rules="rules.rentRate"
          />
        </div>
        <div
          v-if="isInvestor || $can('auto_edit_weekend_schedule')"
          cols="12"
          sm="6"
          md="4"
          class="ma-2"
        >
          <v-select
            v-model="credentials.weekendScheduleId"
            item-value="id"
            item-text="name"
            :label="$t('weekendScheldule.title')"
            :items="$store.state['weekend-schedule'].list"
            :rules="rules.rentRate"
          />
        </div>
        <v-select
          :items="fuelTypes"
          v-model="credentials.fuelId"
          :label="$t('auto.fields.gas') + ' *'"
          item-text="title"
          item-value="id"
          :hide-details="false"
          class="ma-2"
        ></v-select>
        <v-select
          v-model="credentials.transmissionType"
          :label="$t('auto.transmissionType')"
          item-text="text"
          item-value="value"
          class="ma-2"
          :items="transmissionTypes"
          :rules="rules.transmission"
        />
        <v-text-field
          v-model="credentials.engineCapacity"
          :label="$t('auto.fields.engine') + ' *'"
          :placeholder="$t('auto.fields.enginePlaceholder')"
          :rules="rules.engine"
          v-mask="'#.##'"
          type="text"
          class="ma-2"
          autocomplete="off"
        />
        <v-text-field
          v-model="credentials.tireSize"
          :label="$t('auto.fields.tireSize')"
          type="text"
          class="ma-2"
          autocomplete="off"
        />
        <v-text-field
          v-model="credentials.bodyNumber"
          :label="$t('auto.fields.bodyNumber') + ' *'"
          :placeholder="$t('auto.fields.bodyNumberPlaceholder')"
          :rules="rules.bodyNumber"
          type="text"
          class="ma-2"
          autocomplete="off"
        />
        <v-text-field
          v-model="credentials.tachometer"
          :label="$t('auto.fields.tachometr')"
          type="text"
          class="ma-2"
          autocomplete="off"
          readonly
        />
      </v-col>
      <v-col cols="12" sm="12" md="4">
        <v-select
          :items="locations"
          v-model="credentials.locationId"
          :label="$t('auto.fields.location') + ' *'"
          item-text="title"
          item-value="id"
          :hide-details="false"
          class="ma-2"
        ></v-select>
        <div cols="12" sm="6" md="4" class="ma-2">
          <rate-date-input v-model="credentials.rentRateDate" />
        </div>
        <v-combobox
          v-model="credentials.companyId"
          :items="companies"
          :label="$t('auto.fields.company') + ' *'"
          :rules="rules.company"
          :disabled="isCompanyDisabled"
          item-text="name"
          item-value="id"
          class="ma-2"
        />
        <v-combobox
          v-model="credentials.investorId"
          :items="investors"
          :label="$t('auto.fields.investor') + ' *'"
          :rules="rules.investor"
          :disabled="isInvestorDisabled"
          item-value="id"
          item-text="name"
          class="ma-2"
        />
        <v-text-field
          v-model="credentials.rentShiftPrice"
          :label="$t('auto.fields.shiftPrice') + ' *'"
          :placeholder="$t('auto.fields.shiftPricePlaceholder')"
          :rules="rules.price"
          type="text"
          class="ma-2"
          autocomplete="off"
        />
        <v-text-field
          v-model="credentials.rentDayPrice"
          :label="$t('auto.fields.dayPrice') + ' *'"
          :placeholder="$t('auto.fields.dayPricePlaceholder')"
          :rules="rules.price"
          type="text"
          class="ma-2"
          autocomplete="off"
        />
        <v-text-field
          v-model="credentials.registrationCertificate"
          :label="$t('auto.fields.registrationСertificate')"
          class="ma-2"
        />
        <v-checkbox
          v-if="$can('auto_edit_active_state')"
          color="primary"
          v-model="credentials.notActive"
          :label="$t('common.fields.isAutoUnactive')"
          class="ma-2"
          :input-value="credentials.notActive"
          @change="changeAutoActiveStatus"
        ></v-checkbox>
        <v-textarea
          v-if="credentials.notActive"
          v-model="credentials.comment"
          outlined
          :label="$t('common.fields.inactivityReason') + ' *'"
          :rules="rules.comment"
          class="ma-2"
        ></v-textarea>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapMutations } from 'vuex';
import { mask } from 'vue-the-mask';
import ParkSelect from '@/components/auto/AutoForm/ParkSelect.vue';
import BrandSelect from '@/components/auto/AutoForm/BrandSelect.vue';
import ModelSelect from '@/components/auto/AutoForm/ModelSelect.vue';
import RateDateInput from '@/components/auto/AutoForm/RateDateInput.vue';

export default {
  name: 'MainInfo',
  directives: {
    mask,
  },
  components: {
    ParkSelect,
    BrandSelect,
    ModelSelect,
    RateDateInput,
  },
  data() {
    return {
      numberValidating: false,
      numberErrors: [],
      credentials: {
        parkId: null,
        rentRateId: null,
        weekendScheduleId: null,
        rentRateDate: null,
        number: null,
        carBrandId: null,
        carModelId: null,
        year: null,
        carTypeId: 3,
        fuelId: 1,
        engineCapacity: null,
        bodyNumber: null,
        tachometer: null,
        locationId: 12,
        companyId: null,
        investorId: null,
        rentShiftPrice: null,
        rentDayPrice: null,
        notActive: false,
        transmissionType: null,
        registrationCertificate: '',
        comment: '',
        tireSize: '',
        responsible_fines_id: null,
      },
      rules: {
        rentRate: [
          (v) => !!v || this.$t('common.fields.validation.field.required'),
        ],
        number: [
          (v) => !!v || this.$t('common.fields.validation.field.required'),
          (v) =>
            /^[a-zа-яәғёқңөұүһіA-ZА-ЯӘҒЁҚҢӨҰҮҺІ0-9]{5,10}$/.test(v) ||
            this.$t('auto.fields.validation.number'),
        ],
        brand: [
          (v) =>
            v.id !== null || this.$t('common.fields.validation.field.required'),
        ],
        model: [
          (v) =>
            v.id !== null || this.$t('common.fields.validation.field.required'),
        ],
        year: [
          (v) => !!v || this.$t('common.fields.validation.field.required'),
          (v) =>
            (/^([0-9][0-9][0-9][0-9])$/.test(v) &&
              parseInt(v, 10) <= new Date().getFullYear()) ||
            this.$t('common.fields.validation.greaterYear'),
        ],
        engine: [
          (v) => !!v || this.$t('common.fields.validation.field.required'),
          (v) =>
            /^([1-9])\.([0-9]{1,2})$/.test(v) ||
            this.$t('common.fields.validation.engineFormat'),
        ],
        transmission: [
          (v) => {
            const isValid = !!v || v === 0;
            return (
              isValid || this.$t('common.fields.validation.field.required')
            );
          },
        ],
        bodyNumber: [
          (v) => !!v || this.$t('common.fields.validation.field.required'),
          (v) =>
            /^[a-zA-Z0-9]{8,20}$/.test(v) ||
            this.$t('auto.fields.validation.bodyNumber'),
        ],
        tachometr: [
          (v) => !!v || this.$t('common.fields.validation.field.required'),
          (v) =>
            /^[0-9]{1,12}$/.test(v) ||
            this.$t('common.fields.validation.tachometr'),
        ],
        company: [
          (v) => !!v || this.$t('common.fields.validation.field.required'),
        ],
        investor: [
          (v) => !!v || this.$t('common.fields.validation.field.required'),
        ],
        price: [
          (v) => !!v || this.$t('common.fields.validation.field.required'),
          (v) =>
            /^[0-9]{1,12}$/.test(v) ||
            this.$t('common.fields.validation.price'),
        ],
        comment: [
          (v) => !!v || this.$t('common.fields.validation.field.required'),
          (v) =>
            /^.{0,300}$/.test(v) || this.$t('common.fields.validation.comment'),
        ],
        color: [
          (v) => !!v || this.$t('common.fields.validation.field.required'),
        ],
      },
    };
  },
  props: {
    autoDetails: Object,
  },
  computed: {
    ...mapGetters({
      brand: 'auto/getAutoBrand',
      brandId: 'auto/getAutoBrandId',
      model: 'auto/getAutoModel',
      types: 'auto/getAutosTypes',
      fuelTypes: 'auto/getFuelTypes',
      locations: 'auto/getAutosLocations',
      companies: 'auto/getAutosCompanies',
      investors: 'auto/getAutosInvestors',
      responsibles: 'auto/getAutosResponsibles',
    }),
    isEdit() {
      return Boolean(this.$route.params.autoId);
    },
    isInvestor() {
      return this.$store.getters['global/getRole'] === 'investor';
    },
    isNumberDisabled() {
      return this.isEdit && !this.$can('car_edit_number');
    },
    isInvestorDisabled() {
      return this.isEdit && !this.$can('car_edit_payment');
    },
    isCompanyDisabled() {
      return this.isEdit && !this.$can('car_edit_company');
    },
    transmissionTypes() {
      return [
        { text: this.$t('auto.transmissionType.manual'), value: '0' },
        { text: this.$t('auto.transmissionType.auto'), value: '1' },
      ];
    },
  },
  methods: {
    ...mapMutations({
      setBrand: 'auto/setAutoFormBrand',
      setModel: 'auto/setAutoFormModel',
      setLoader: 'auto/setAutoLoadingData',
    }),
    getComponentData() {
      this.credentials.carBrandId = this.brandId;
      this.credentials.carModelId = this.model.id;

      this.$emit('update:autoDetails', this.credentials);
    },
    writeDataToFields(data) {
      if (data.brand) {
        this.setBrand(data.brand);
        // eslint-disable-next-line
        delete data.brand;
      }
      if (data.model) {
        const that = this;
        // set model with some hold
        setTimeout(() => {
          that.setModel(data.model);
          // eslint-disable-next-line
          delete data.model;
          that.setLoader(false);
        }, 10);
      }

      this.credentials = data;
    },
    changeAutoActiveStatus() {
      if (!this.credentials.notActive) {
        this.credentials.comment = '';
      }
    },
    async validateIsAutoExisting() {
      const numberInvalid = !this.$refs.number.valid;

      if (this.isEdit || numberInvalid) return;

      this.numberValidating = true;
      const { isExisting } = await this.$store.dispatch(
        'auto/validateAutoNumber',
        this.credentials.number,
      );

      if (isExisting) {
        this.numberErrors = [this.$t('auto.fields.existing-error')];
      }

      this.numberValidating = false;
    },
  },
  created() {
    const { number } = this.$route.query;
    if (number) this.credentials.number = number;
  },
};
</script>

<style lang="scss" scoped></style>
